module.exports = __webpack_public_path__ + "images/speed-two-active.75a19d5a77a78b2ec72867af1b5efed5.png";